<!-- 未支付订单 -->
<template>
  <div>
    <van-dialog
      v-model="show"
      :title="$t('ticket.unpaid.title')"
      :message="$t('ticket.unpaid.msg')"
      show-cancel-button
      :cancelButtonText="$t('ticket.unpaid.cancel')"
      :confirmButtonText="$t('ticket.unpaid.confirm')"
      :confirmButtonColor="'var(--bgColor)'"
      @confirm="wannaPayAgain"
      @cancel="wannaCancleOrder"
    >
    </van-dialog>

    <!-- 加载 -->
    <CusLoading :show="loading" />
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Dialog
} from 'vant'

Vue.use(Dialog)

import CusLoading from '@c/CusLoading'

import { CancelOrder } from '@a/js/api/pay.js'
import wx from 'weixin-js-sdk'
import apiObj from '@a/js/api.js'
export default {
  name: 'CusPayAgain',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderno: {
      type: String,
      default: ''
    },
    payment: {
      type: String,
      default: ''
    },
    payment_method: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      apiObj,
      loading: false,
      params: {},
    };
  },

  computed: {
    program_env() {
      return window.location.host === 'c.banhuiyun.com' ? 'pro' : 'dev'
    },
    is_jump() {
      return this.$root.isJump
    },
    jump_url() {
      return this.$root.jumpUrl
    }
  },

  components: {
    CusLoading
  },

  methods: {
    // 获取参数信息
    GetParamsData() {
      return new Promise(resolve => {
        this.params = this.$route.params;
        resolve();
      });
    },
    // 取消订单
    wannaCancleOrder() {
      this.loading = true
      let data = {
        req_type: 'BTicket',
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        order_no: this.orderno
      }
      // console.log(data)
      CancelOrder(data, this.$root.language).then(res => {
        this.loading = false
        this.$emit('listenCloseDialog')
        this.$notify({
          type: 'success',
          message: res.msg
        })
        this.$storeLocal.remove('ticket_order')
      }).catch(() => {
        this.loading = false
      })
    },
    // 继续支付
    async wannaPayAgain() {
      this.loading = true
      if (this.payment != 'offline') {
        let apiurl = apiObj.VUE_APP_BASE_API + '/g/v1/pay_bhy/pay?req_type=BUnion&account_uid=' + this.params.accountid + '&project_uid=' + this.params.projectid + '&order_no=' + this.orderno + '&return_url='

        let return_url = ''
        
        if (this.is_jump) {
          return_url = this.jump_url
        } else {
          return_url = apiObj.VUE_APP_BASE_SERVE + 'ticket/result/' + this.params.accountid + '/' + this.params.projectid + '/' + this.orderno + '/' + this.$i18n.locale
        }

        if (this.payment == 'wxpay') {
          this.judgeIsMiniProgran().then(() => {
            if (this.payment_method == 'miniprogram') {
              wx.miniProgram.navigateTo({
                url: '/pages/payment/index?req_type=BUnion&account_uid=' + this.params.accountid + '&project_uid=' + this.params.projectid + '&order_no=' + this.orderno + '&env=' + this.program_env + '&return_url=' + return_url,
                success: () => { },
                fail: () => { }
              })
            } else {
              this.$notify({
                type: 'warning',
                message: '该订单不支持在小程序内支付'
              })
              this.loading = false
            }
          }).catch(() => {
            if (this.payment_method == 'miniprogram') {
              this.$notify({
                type: 'warning',
                message: '该订单需在小程序内发起支付流程'
              })
              this.loading = false
            } else {
              let paid_url = apiurl + return_url
              window.location.href = paid_url
            }
          })

        } else {

          // 支付宝 & paypal
          // 拼接 apiurl
          const apiurl = apiObj.VUE_APP_BASE_API + '/g/v1/pay_bhy/pay?req_type=BUnion&account_uid=' + this.params.accountid + '&project_uid=' + this.params.projectid + '&order_no=' + this.orderno + '&return_url='

          // 支付宝支付 & 微信内 & ios 系统
          if (this.payment === 'alipay' &&
            this.judgeIsWeiXin() &&
            await this.JudgeTerminalType() === 'ios'
          ) {
            console.log('weichat & ios')
            this.loading = false
            this.$emit('listenAlipayInWechat', this.orderno, apiurl + return_url)
          }
          else {
            // 支付宝（非微信内 & 非 ios） or paypal 跳转支付
            window.location.href = apiurl + return_url
          }
        }
      } else {
        this.$router.push({
          name: "Result",
          params: {
            accountid: this.params.accountid,
            projectid: this.params.projectid,
            orderid: this.orderno,
            language: this.$i18n.locale
          }
        })
      }

    },
    // 判断是否小程序内打开
    judgeIsMiniProgran() {
      return new Promise((resolve, reject) => {
        wx.miniProgram.getEnv(res => {
          // alert(JSON.stringify(res))
          if (res.miniprogram) {
            resolve()
          }
          reject()
        })
        reject()
      })
    },
    // 判断终端类型
    JudgeTerminalType() {
      return new Promise((resolve, reject) => {

        const uAgent = navigator.userAgent

        if (/(iPhone|iPad|iPod|iOS)/i.test(uAgent)) {
          resolve("ios")
        }
        else if (/(Android)/i.test(uAgent)) {
          resolve("android")
        }
        else {
          resolve("other")
        }
      })
    },
    // 判断是否微信浏览器
    judgeIsWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      // console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    }
  },

  mounted() {
    this.GetParamsData()
  },
}
</script>
<style lang='less' scoped></style>